import {useState, useEffect} from "react"
import {Aff_question} from "./Aff_question"
import {MathJaxContext } from "better-react-mathjax";

export function ErreursEleve ({auth}) {

	const [tabErreur, setTabErreur] = useState([])
	const [nbActivite, setNbActivite] = useState(5)
	const [isErreur, setIsErreur] = useState(true)

	const handleClick = (e) => {
		fetch("https://maths-au-quotidien.fr/react-automaths/api-database_test.php", {
	    method: 'POST',
	    body: JSON.stringify({...auth, action:'recup_erreurs_eleve', activite:e.target.title})
		})
		.then(response => response.json())
		.then(data => {
			setTabErreur(data)
			setIsErreur(data[0] ? true : false)
			setTimeout(() => setIsErreur(true), 3000)
		})
		.catch(err => console.log(err))
	}

	useEffect(()=>{
	  if(typeof window?.MathJax !== "undefined"){
	    window.MathJax.typeset()
	  }
	},[tabErreur]); // MathsJax 
	//console.log(auth) Object.keys(auth.activites)
	//console.log(isErreur)
	//console.log('tabErreur', tabErreur)
 	return (
	    <div className="content max">
	    	<h1>Mes erreurs</h1>
	    	Choisir une activité : <br/>
	    	{
	    		Object.keys(auth.activites).map((e, k) => k < nbActivite && <span key={k} className="btn_param" title={e} onClick={handleClick}>{auth.activites[e].title || e}</span>)
	    	}

	    	{
	    		nbActivite < 1000 && <span className="btn_param" onClick={()=>{
		    							const nb = nbActivite
		    							const add = Object.keys(auth.activites).length < nb ? 1000 : 10
		    							setNbActivite(nb+add > Object.keys(auth.activites).length ? 1000 : nb+add)
		    						}}>...</span>
		    }
		    <br/>
	    	{
	    		tabErreur.length ? tabErreur.map((e,k)=> <span key={k}>
	    			<MathJaxContext><Aff_question question={e} /></MathJaxContext>
					</span>) : ''
	    	}
	    	<br/><br/>
	    	{
	    		/*tabErreur.length ? 
	    			<button className="btn" value="refaire"/>
					: ''*/
	    	}

	    	{
	    		!isErreur ? <div className='info fadeout3'>
	    			<br/>
	    			Vous n'avez pas d'erreur pour cette activité.
	    			<br/><br/>
					</div> : ''
	    	}
	    </div>
 	);
}